import getEnvironment from 'env-config/get-environment';
import { Timing } from 'static/models/enums/timing';

export default function getDemoVideoSource(timing: Timing): string {
    return `${getEnvironment().efuneralMediaBucket}/efuneral-demo-videos/${timing
        .toString()
        .toLowerCase()}-demo-video.mp4`;
}
